import { httpPost, timeoutError } from "./HttpRequest";
import * as Urls from './Urls';

/**
 * ログイン情報の取得
 */
export async function getLoginInfo():Promise<any>{
    try
    {
        let loginInfo:[] = [];
        const form = new FormData();
        await httpPost(Urls.URL_LOGIN + "?data" ,form ,{
            "success" : (data :any) => {
                if(data.status == 0){
                    loginInfo = data.payload;
                }
            },
            "timeout" : () => {
                throw new timeoutError();
            },
            "error" : (code:number , message:string) => {
                throw new Error("Code:" + code + "Message:" + message);
            }
        });

        return loginInfo;
    }catch(e){
		throw e;
	}
}